import React, { useCallback, useContext } from 'react'
import PropTypes from 'prop-types'
import { get, set, identity, first } from 'lodash'

import FilterBarContext from '../context'
import { findSectionElement } from '../utils'
import { RadioButtonGroup, RadioButton } from '../../RadioButton'

const RadioList = ({ items, onChange, hierarchy }) => {
  const { filters, serverSideT } = useContext(FilterBarContext)

  const onChangeHandler = useCallback(
    (selectedValue) => {
      onChange((filters, newSections) => {
        const clonedFilters = { ...filters }
        set(clonedFilters, hierarchy, selectedValue)

        const clonedNewSections = [...newSections]
        const sectionElement = findSectionElement(clonedNewSections, hierarchy)

        sectionElement.selected = selectedValue

        return { clonedFilters, clonedNewSections }
      }, hierarchy)
    },
    [onChange, hierarchy]
  )

  return (
    <RadioButtonGroup
      orientation='vertical'
      labelPosition='right'
      onChange={onChangeHandler}
      name={hierarchy.join('')}
      defaultSelected={get(filters,hierarchy)}
    >
      {items.map(({ val, label }) => (
        <RadioButton
          id={`${hierarchy.join('-')}-${label}`}
          key={`${hierarchy.join('-')}-${label}`}
          value={val}
          labelText={serverSideT(label)}
        />
      ))}
    </RadioButtonGroup>
  )
}

RadioList.propTypes = {
  items: PropTypes.array,
  onChange: PropTypes.func,
  hierarchy: PropTypes.arrayOf(PropTypes.string)
}

RadioList.defaultProps = {
  items: [],
  onChange: identity,
  hierarchy: []
}

export default React.memo(RadioList)
